import pkgJson from '../package.json';

export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

export {
    content3DSchema,
    defaultContent3DConfig,
    defaultContent3DData,
    defaultContent3DI18n,
    hasConfigured3DModel,
    type Content3DContent,
    type Content3DData,
    type Content3DConfig,
    type Content3DAnswer,
    type Model3DFormat,
    type LightPreset,
    type Model3DObjectInteraction,
} from './schema';

export { Content3DEdit, type Content3DEditProps } from './Content3DEdit';
export { Content3DPlayer, type Content3DPlayerProps } from './Content3DPlayer';

export { content3DContentGrader, validate3DSubmission } from './grader';
export { content3DValidator } from './validator';

export { loadModel3D, disposeObject3D, type LoadedModel } from './lib/loadModel';
export {
    extractModelOutline,
    extractObjectPaths,
    extractOutlineFromFile,
    objectPathLeaf,
    objectPathParent,
    findObjectByPath,
    OBJECT_PATH_SEP,
    type Model3DOutline,
} from './lib/modelOutline';
export {
    subscribePreviewHighlight,
    requestPreviewHighlight,
    type PreviewHighlightRequest,
} from './lib/previewHighlight';
export {
    ObjectInteractionList,
    type ObjectInteractionListProps,
} from './components/ObjectInteractionList';
export {
    uploadModel3D,
    requestModel3DToken,
    deleteModel3D,
    uploadModel3DEnvironment,
    setModel3DTenantId,
    fetchModel3DOutline,
    saveModel3DOutline,
    type Model3DUploadResult,
    type Model3DTokenResult,
    type Model3DOutlineResult,
} from './api';

export { content3DSchema as default } from './schema';
